import {h} from 'preact/dist/preact';
import {Link} from 'react-router-dom';
import Icon from '@components/common/Icon';
import Button from '@components/common/Button';
import ProductImage from '@components/common/ProductImage';
import {EquipmentModelDetail, InjuryBadge} from '../components';
import {labels} from '../styles';
import cx from 'classnames';
import pluralize from 'pluralize';

export const CheckoutButton = ( {count, className = '', location} ) => (
    <Link className={`button primary ${className}`} to={{pathname: '/checkout', state: {fromPath: location.pathname}}}>
        <Icon.ui name="shopping-cart" center className="mr-2 text-xl"/>
        <span>Proceed with ({count}) {pluralize( 'repair', count )}</span>
    </Link>
);

export const CheckoutLineItem = ( {onRemoveItem, ...props} ) =>
    <div key={props.serialId} className="mt-12 flex w-full">
        <div className="flex-shrink self-center w-16">
            <ProductImage className="w-full" images={props.images} width="48" kitName={props.itemName}/>
        </div>
        <div className="mt-2 ml-8 flex-1 md:flex justify-between">
            <div className="flex-1 lg:ml-6">
                <h4 className={labels.itemName}>{props.itemName}</h4>
                <EquipmentModelDetail className="mt-2" {...props} />
            </div>
            {props.openRma
                ? <div className="flex-1 max-w-md md:ml-8 lg:w-80 text-fail">
                    <h4 className="mt-4 md:mt-0 leading-tight">This item in not eligible for repair</h4>
                    <p>This item is already associated with an open repair request and must be removed before continuing.</p>
                    <Link className="mt-2 block link-2"
                          to={`/open-repairs/${props.openRma.requestId}`}>View open repair</Link>
                </div>
                : <div className="flex-1 max-w-md md:ml-8">
                    <h4 className="mt-4 md:mt-0 leading-tight">Warranty information</h4>
                    <p>{props.yearsCoverage} years beginning {props.warrantyCoverageStart}</p>
                    <h4 className="mt-4 leading-tight">Described equipment issues</h4>
                    <p>{props.equipmentIssue}</p>
                    <InjuryBadge hasInjury={props.injury}/>
                </div>
            }
            <Button type="button" secondary small
                    icon="remove"
                    className={cx( 'mt-2 flex-0 md:ml-6 self-center', {error: !!props.openRma} )}
                    onClick={() => onRemoveItem( {serialId: props.serialId} )}>
                Remove
            </Button>
        </div>
    </div>;